import { render, staticRenderFns } from "./AtomContactDetail.vue?vue&type=template&id=2b45921e&scoped=true&"
import script from "./AtomContactDetail.vue?vue&type=script&lang=js&"
export * from "./AtomContactDetail.vue?vue&type=script&lang=js&"
import style0 from "./AtomContactDetail.vue?vue&type=style&index=0&id=2b45921e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45921e",
  null
  
)

export default component.exports